<template>
	<div class="nomination_supercat_contest_box">

		<contest-banner
		:contest="contest"
		:label="contest.label"
		:icon="supercat_icon"
		:lead_image="contest.lead_image"
		:banner_type="contest_banner_type"
		:is_expanded="show_contest_nomination_card"
		@click.native="toggle_nomination_card()"
		></contest-banner>

		<div class="nomination_list_box_wrapper"
		v-if="list_type == 'nominations'"
		>

			<transition 
			name="" 
			enter-active-class="animated bounceInLeft faster" 
			leave-active-class="animated bounceOutRight faster"
			>
			
				<nomination-card
				v-if="show_contest_nomination_card"
				:instance_contestid="contest.instance_contestid"
				:nomination_save_status="nomination_save_result"
				:nomination_save_in_progress="nomination_save_in_progress"
				:reset_nomination_requested="reset_nomination"
				@record_nomination_from_contest="nomination_listener"
				@request_nomination_reset="reset_nomination_status"
				></nomination-card>
			
			</transition>

		</div>

	</div>
</template>

<script>
import ContestBanner from '@/features/contests/contest_banner.vue';
import NominationCard from '@/features/nominate/nominate_card.vue';

export default {
	name: 'NominationSupercatContestBox',
	props: [
		'contest',
		'list_type',
		'supercat_icon'
	],
	data () {
	return {
		contest_banner_type: 'contest',
		show_contest_nomination_card: false,
		nomination_details: {},
		nomination_save_result: false,
		nomination_save_in_progress: false,
		reset_nomination: false
	}
	},
	computed: {
	
	},
	methods: {
		toggle_nomination_card() {
			if(this.list_type == 'nominations') {
				this.show_contest_nomination_card = !this.show_contest_nomination_card;
			}
			else if(this.list_type == 'voting') {
				this.goto_path('/votenow', this.contest.instance_contestid);
			}
		},
		goto_path: function(path_name, param) {
			this.$root.store.goto_path(path_name, param);
		},
		reset_nomination_status() {
			this.$set(this, 'nomination_save_result', false);
			this.$set(this, 'nomination_save_in_progress', false);
			this.$set(this, 'reset_nomination', false);
		},
		nomination_listener(nomination_text) {
			let vm = this;

			// SET LOCAL VARS WITH NOMINATION DETAILS
			vm.nomination_details.nomination_text = nomination_text;
			vm.nomination_details.contest = vm.contest;

			// BUILD DATA OBJECT FOR SAVING
			let data = {
				instance_contestid: vm.contest.instance_contestid,
				nomination_text: nomination_text,
				user_publicid: this.$root.store.session.get_userid()
			}

			// SET NOMINATION SAVE TO IN PROGRESS
			// vm.nomination_save_in_progress = true;
			vm.$set(vm, 'nomination_save_in_progress', true);

			// REQUEST NOMINATION SAVE
			vm.$root.store.nominations.record_nomination(data)
				.then(function(response) {
					// console.log('response: ', response);

					// RESET IN PROGRESS STATUS
					// vm.nomination_save_in_progress = false;
					vm.$set(vm, 'nomination_save_in_progress', false);

					if(response.data.data.success === true) {
						// vm.nomination_save_result = true;
						vm.$set(vm, 'nomination_save_result', true);

						// FIRE GA EVENT
						vm.$ga.event({
							eventCategory: 'Nominations',
							eventAction: vm.contest.label,
							eventLabel: vm.nomination_details.nomination_text
						})

						// SET TIMER TO RESET NOMINATION
						setTimeout(function() {
							vm.$set(vm, 'reset_nomination', true);
						}, 2000);
					
					}
					else {
						console.log('nomination save error: ');
					}
				})
			
		}
	},
	components: {
		ContestBanner,
		NominationCard
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.nomination_supercat_contest_box {

}
</style>



// WEBPACK FOOTER //
// src/features/nominate/nominate_supercat_contest_box.vue